import * as Sentry from '@sentry/nextjs';

/**
 * Öffnet das Sentry-Feedback-Formular ("Fehler melden") manuell — die
 * `feedbackIntegration` läuft mit `autoInject: false`, es gibt also keinen
 * schwebenden Button mehr (siehe instrumentation-client.ts). Das Formular wird
 * stattdessen aus dem Konto-Menü heraus über diesen Helper geöffnet.
 *
 * Das Formular wird einmalig erzeugt und in den DOM gehängt; wiederholte
 * Aufrufe öffnen dieselbe Instanz erneut (kein mehrfaches `appendToDom`).
 */
type FeedbackForm = Awaited<
  ReturnType<NonNullable<ReturnType<typeof Sentry.getFeedback>>['createForm']>
>;

let formPromise: Promise<FeedbackForm | undefined> | null = null;

export async function openErrorFeedback(): Promise<void> {
  const feedback = Sentry.getFeedback();
  // Kein Feedback-Integration (z.B. DSN fehlt / SSR) → still no-op.
  if (!feedback) return;

  if (!formPromise) {
    formPromise = feedback.createForm().then((form) => {
      form.appendToDom();
      return form;
    });
  }

  const form = await formPromise;
  form?.open();
}
